import React from "react";
import { Message } from "primereact/message";
import S from "./ValidationMessage.module.scss";
import { useAtlasTheme } from "../../helpers";

interface ValidationMessageProps {
  severity: "success" | "info" | "warn" | "error";
  text: React.ReactNode;
  className?: string;
  /** Optional id for aria-describedby linkage from form inputs */
  id?: string;
  /** Optional ARIA role, e.g. "alert" for error messages */
  role?: string;
  /** data-testid applied to the wrapping div; omit when rendered per-field/per-item to avoid duplicate test ids */
  testId?: string;
}

/**
 * ValidationMessage component based on PrimeReact's Message component
 * with added styling for better visibility and softer appearance.
 */
export const ValidationMessage: React.FC<ValidationMessageProps> = ({
  severity,
  text,
  className = "",
  id,
  role,
  testId,
}) => {
  const isAtlas = useAtlasTheme();
  return (
    <div
      id={id}
      role={role}
      data-testid={testId}
      className={`${!isAtlas && S.validationMessage} ${!isAtlas && S[severity]} ${className}`}
    >
      <Message severity={severity} text={text} />
    </div>
  );
};

export default ValidationMessage;
